import React, { useEffect, useState } from "react";
import { Link, withRouter, useHistory } from "react-router-dom";
import { connect } from "react-redux";
import {
  setCartQuantity,
  addCartItem, 
  removeCartItem,
} from "../../redux/actions/cart_actions";
import { getWishList, addToWishList } from "../../redux/actions/user_actions";
import Swal from 'sweetalert2';
import Rating from '@material-ui/lab/Rating';
import ImageGallery from 'react-image-gallery';
import Skeleton from 'react-loading-skeleton';

const CardDetail = ({ ...props }) => {  
  const history = useHistory()
  let userInfo = JSON.parse(localStorage.getItem("user"))

  const formatter = new Intl.NumberFormat('de-DE', {
    style: 'currency',
    currency: 'VND',
    minimumFractionDigits: 0
  })
  const id = window.location.pathname.split("/").pop();

  const [quantity, setQuantity] = useState(1)
  const [favorite, setFavorite] = useState(null)

  useEffect(() => {
    setQuantity(1)
    if(userInfo) {      
      props.dispatch(getWishList(userInfo.customerId, id)).then(res => {
        if(res.payload) {
          setFavorite(res.payload.wishList.isFavorite)
        }
      })
    }
  }, [window.location.pathname])

  const handleIncreaseQuantity = () => {    
    let newQuantity = quantity + 1

    // Check stock and product quantity in cart
    let index = props.cart.carts.findIndex((c => c.productId == props.product.productId))
    if(index > -1) {
      if(props.product.stockQuantity < (newQuantity + props.cart.carts[index].quantity))
        return
    }
    else {
      if(quantity >= props.product.stockQuantity)
        return
    }

    setQuantity(newQuantity);
  }
  
  const handleDecreaseQuantity = () => {
    let newQuantity = quantity - 1

    if(quantity <= 1)
      return

    setQuantity(newQuantity);
  }

  const handleAddToCart = () => {
    let cart = { 
      productId: props.product.productId, 
      productName: props.product.productName,
      stock: props.product.stockQuantity,
      material: props.product.material,
      color: props.product.color,
      image: props.product.image,
      notes: props.product.notes,
      price: props.product.price,
      quantity: parseInt(quantity) 
    }
    
    if(!userInfo) {
      return history.push("/login")
    }
    // Khi sản phẩm đã thêm vào giỏ hàng => cập nhật số lượng
    let index = props.cart.carts.findIndex((s => s.productId == props.product.productId))
    if(index > -1) {
      if(props.product.stockQuantity >= (quantity + props.cart.carts[index].quantity)) {
        props.dispatch(addCartItem(cart, props.cart.carts))
        props.dispatch(setCartQuantity(props.cart.carts))
        // console.log(props.cart.carts)
        return(
          Swal.fire({
            title: '',
            text: 'Đã cập nhật số lượng vào giỏ hàng',
            icon: 'success',
            showCancelButton: true,
            confirmButtonColor: '#000000',
            confirmButtonText: 'Xem',
            cancelButtonColor: '#999897',
            cancelButtonText: 'Đóng',
            reverseButtons: true
          }).then((result) => {
            if(result.value)
              history.push("/cart")
          })  
        )
      }
    }
    else {          
      props.dispatch(addCartItem(cart, props.cart.carts))
      props.dispatch(setCartQuantity(props.cart.carts))
      // console.log(props.cart.carts)
      Swal.fire({
        title: '',
        text: 'Sản phẩm đã thêm vào giỏ hàng',
        icon: 'success',
        showCancelButton: true,
        confirmButtonColor: '#000000',
        confirmButtonText: 'Xem',
        cancelButtonColor: '#999897',
        cancelButtonText: 'Đóng',
        reverseButtons: true
      }).then((result) => {
        if(result.value)
          history.push("/cart")
      })  
    }
  }

  const handleAddToWishList = () => {
    let dataToSubmit = {
      customerId: userInfo.customerId,
      productId: id,
      isFavorite: !favorite
    }
    props.dispatch(addToWishList(dataToSubmit)).then(res => {
      if(!res.payload) {
        Swal.fire({
          title: 'Phiên đăng nhập đã hết hạn!',
          text: 'Vui lòng đăng nhập lại',
          icon: 'warning',
          confirmButtonText: 'Đóng',
          confirmButtonColor: '#000000',
        }
        ).then((ok) => {
            if(ok) {
              history.push("/login")
              localStorage.removeItem("user")
            }
        })   
      }
    })
    setFavorite(!favorite)
  }

  const renderStock = () => {
    if(props.product.stockQuantity > 0)
      return(
        <b>Còn {props.product.stockQuantity} sản phẩm</b>
      )
    return(
      <b>Tạm hết hàng</b>
    )
  }

  const renderButtonAddToCart = () => {
    if(props.product.stockQuantity > 0)
      return(
        <button type="button" className="btn btn-md btn-default btn-round o" onClick={handleAddToCart} ><i className="fa fa-shopping-cart"></i> Thêm Vào Giỏ</button>
      )
    return(
        <button type="button" className="btn btn-md btn-default btn-round o">Sản Phẩm Tạm Hết</button>
    )
  }

  const renderButtonAddToWishList = () => {
    if(userInfo) {
      if(favorite) {
        return(
          <button type="button" className="btn btn-md btn-round btn-outline-danger o" onClick={handleAddToWishList}><i className="fa fa-heart"></i> Yêu Thích</button>
        )
      }
      else {
        return(
          <button type="button" className="btn btn-md btn-round btn-outline-default o" onClick={handleAddToWishList}><i className="fa fa-heart"></i> Yêu Thích</button>
        )
      }
    }
  }

  const renderQuantity = () => {
    if(props.product.stockQuantity > 0)
      return(
        <>
          <div className="col-md-6"><label>Số lượng</label></div>
          <div className="col-md-6" style={{ fontSize:18 }}>
            <a className="decreaseQuantity" onClick={handleDecreaseQuantity}><i className="far fa-minus-square" aria-hidden="true"></i></a> 
            <b id={`productCartQuantity${props.productId}`} style={{ padding:10 }}> {quantity} </b>
            <a className="increaseQuantity" onClick={handleIncreaseQuantity}><i className="far fa-plus-square" aria-hidden="true"></i></a>
          </div>
        </>
      )
    return(null)
  }

  const renderCarousel = () => {
    let images = props.productImageDetail.map(element => {
      return {
        original: element.image,
        thumbnail: element.image,
      }
    })
    
    if(props.productImageDetail && props.productImageDetail.length > 0) {
      return(
        <ImageGallery items={images} showPlayButton={false} useBrowserFullscreen={false} />
      )
    }
  }

  return (
    <>
    <div className="row cardDetailSpacing">
      <div className="col-md-8 col-xs-12">
        {renderCarousel()}
      </div>
      <div className="col-md-4 col-xs-12">
        <div className="container">
          <div className="productName">{props.product.productName}</div>
          <div>{props.product.notes}</div>           
          <div className="row" style={{ marginTop:10,  }}>
            <div className="col" style={{ paddingTop:20 }}>
              <div className="row">
                <div className="col-md-6">Chiều cao:</div>
                <div className="col-md-6"><b>{props.product.height} cm</b></div>
              </div>
              <hr className="divider" />
              <div className="row">
                <div className="col-md-6">Chiều rộng:</div>
                <div className="col-md-6"><b>{props.product.width} cm</b></div>
              </div>
               <hr className="divider" />
              <div className="row">
                <div className="col-md-6">Chiều dài:</div>
                <div className="col-md-6"><b>{props.product.length} cm</b></div>
              </div>
               <hr className="divider" />
              <div className="row">
                <div className="col-md-6">Chất liệu:</div>
                <div className="col-md-6"><label className="label label-default mr-1">{props.product.material}</label></div>
              </div>
               <hr className="divider" />
              <div className="row">
                <div className="col-md-6">Màu sắc:</div>
                <div className="col-md-6"><b>{props.product.color}</b></div>
              </div>
               <hr className="divider" />
              <div className="row">
                <div className="col-md-6">Tình trạng:</div>
                  <div className="col-md-6"> {renderStock()} </div>
              </div>
               <hr className="divider" />
              <div className="row">
                <div className="col-md-6">Đánh giá:</div>
                  <div className="col-md-6"> 
                    <Rating
                      name="read-only"
                      readOnly
                      value={props.product.ratingStar}
                    />
                  </div>
              </div>
               <hr className="divider" />
            </div>
          </div>    
          <div className="row">
            {renderQuantity()}
          </div>   
          <div className="productPrice"><h6>{formatter.format(props.product.price)}</h6></div>
          <div className="row mb-4">
            <div className="col-md-6">
              {renderButtonAddToCart()}    
            </div>
            <div className="col-md-6">
              {renderButtonAddToWishList()}    
            </div>
          </div>
        </div>       
      </div>
    </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    cart: state.cart,
  };
};

export default connect(mapStateToProps)(CardDetail);